import React, { PureComponent } from 'react';
import styled from 'styled-components';
import plotly from './../node_modules/plotly.js/dist/plotly.js';
import createPlotlyComponent from 'react-plotly.js/factory';
import IconCSV from './assets/Icon_CSV.svg';

const UseCaseWrapper = styled.div`
  grid-column: span 6;
  @media (min-width: 1024px) {
    grid-column: span 6;
  }
  background: white;
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 rgba(38, 47, 51, 0.3);
  color: #42515a;
  margin-bottom: 20px;
  position: relative;
  display: grid;
`;

const TopSectionWrapper = styled.div`
  display: grid;
  padding: 12px 22px 0 27px;
  overflow: auto;
  grid-row: span 8;
`;

const SegmentWrapper = styled.div`
  grid-column: 1/4;
`;

const BottomSectionWrapper = styled.div`
  padding: 20px 22px;
  border-top: 1px dashed gray;
  grid-row: span 1;
`;

const StyledH3 = styled.h3`
  font-size: 18px;
  padding: 15px 0;
`;

const StyledH4 = styled.h4`
  font-size: 16px;
  font-family: latoblack;
  margin-top: 20px;
`;

const StyledMiniPlot = styled.div`
  grid-column: 5 / 6;
  text-align: center;
  display: inline-block;
  position: relative;
`;
const MiniPlotPercent = styled.div`
  color: #2cc4f4;
  font-size: 29px;
  font-family: latoregular;
  position: absolute;
  top: 36px;
  left: 50%;
  width: 100px;
  height: 100px;
  /* margin-top: -50px; */
  margin-left: -50px;
  font-size: 22px;
  line-height: 100px;
  vertical-align: middle;
  text-align: center;
`;
const MiniPlotLegend = styled.div`
  color: #6d7b80;
  font-size: 12px;
  padding-bottom: 10px;
  margin-top: -5px;
`;

const StyledDescription = styled.div`
  font-size: 14px;
`;

const ListWraper = styled.div`
  font-size: 14px;
  margin-bottom: 35px;
`;

const StyledUL = styled.ul`
  margin-left: -12px;
`;

const DownloadFileWrapper = styled.div`
  grid-column: span 3;
  @media (min-width: 380px) {
    grid-column: span 3;
  }
  display: inline-block;
`;

const StyledIcon = styled.img`
  width: 40px;
  height: 40px;
  display: inline-block;
`;

const LastDataWrapper = styled.div`
  font-size: 12px;
  color: #6d7b80;
  vertical-align: bottom;
  width: 150px;
  padding: 0 0 5px 12px;
  display: inline-block;
`;

const StyledButton = styled.button`
  display: inline-block;
  color: white;
  background-color: #2cc4f4;
  border-color: none;
  border: 0;
  font-size: 0.8em;
  padding: 0.8em 1.2em;
  border-radius: 5px;
  cursor: pointer;
  font-family: latoregular;
`;

const ButtonWrapper = styled.div`
  padding: 0px;
  float: right;
  margin-right: 20px;
  margin-top: 10px;
`;
const APILink = styled.a`
  font-size: 12px;
  color: #6d7b80;
  display: inherit;
  margin-top: 5px;
  &:visited {
    color: #6d7b80;
  }
`;

class DataUseCaseItemComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  createList(elements) {
    let list = [];
    elements.forEach(element => {
      list.push(<li>{element['Feature']}</li>);
    });
    return list;
  }

  createActions(elements) {
    let list = [];
    elements.forEach(element => {
      list.push(element['Action']);
    });
    return list;
  }

  createPlot(data) {
    const Plot = createPlotlyComponent(plotly);
    data[0].hole = 0.6;
    data[0].textposition = 'none';

    let layout = {
      height: 170,
      width: 170,
      showlegend: false,
      margin: {
        l: 20,
        r: 20,
        b: 20,
        t: 20,
        pad: 15
      },
      colorway: ['#f0f2f2', '#2cc4f4']
    };

    let config = {
      displayModeBar: false
    };

    return <Plot data={data} layout={layout} config={config} />;
  }

  render() {
    return (
      <UseCaseWrapper>
        <TopSectionWrapper>
          <SegmentWrapper>
            <StyledH3>{this.props.Titel}</StyledH3>
            <StyledDescription>
              {this.props.Description}
              <br />
              Mögliche Massnahme: {this.createActions(this.props.Action)}
            </StyledDescription>
            <StyledH4>Segmentspezifische Eigenschaften</StyledH4>
            <ListWraper>
              <StyledUL>{this.createList(this.props.Features)}</StyledUL>
            </ListWraper>
          </SegmentWrapper>

          <StyledMiniPlot>
            {this.createPlot(this.props.MiniChart)}
            <MiniPlotPercent>
              {this.props.MiniChart[0].values[0]}%
            </MiniPlotPercent>
            <MiniPlotLegend>Anteil Gesamtkunden</MiniPlotLegend>
          </StyledMiniPlot>
        </TopSectionWrapper>
        <BottomSectionWrapper>
          <DownloadFileWrapper>
            <StyledIcon src={IconCSV} alt="csv" />
            <LastDataWrapper>Stand {this.props.lastUpdated}</LastDataWrapper>
          </DownloadFileWrapper>

          <ButtonWrapper>
            <a
              href={'/' + this.props.API + this.props.id + '?type=csv'}
              target="blank"
            >
              <StyledButton>
                Download ({this.props.N} Verträge/Kunden)
              </StyledButton>
            </a>
          </ButtonWrapper>

          <APILink href={'/' + this.props.API + this.props.id} target="blank">
            {'/' + this.props.API + this.props.id}
          </APILink>
        </BottomSectionWrapper>
      </UseCaseWrapper>
    );
  }
}

export default DataUseCaseItemComponent;
